/**
 * @file colors.ts
 *
 * @fileoverview Colors utility methods for generating classes and types for components that need to use
 * dynamic responsive colors like color and background-color.
 */

import { jobiqoCSSModuleClasses } from "../types/cssModules";
import { getClasses } from "../utils/responsive";

export type ColorsProps = {
  color?: string | string[];
  backgroundColor?: string | string[];
};
export const colorProperties = ["color", "backgroundColor"];

export const generateColorClasses = (
  { color, backgroundColor }: ColorsProps,
  styles: jobiqoCSSModuleClasses | null = null
): string => {
  return `
    ${getClasses(styles, "color", color)}
    ${getClasses(styles, "bg", backgroundColor)}
  `.trim();
};

/**
 * Excludes any props related to color from the list of props.
 *
 * To avoid React warnings of elements passed to the DOM such as "backgroundColor" we have to
 * exclude unwanted props from being rendered to the DOM.
 *
 * @param props
 *   The list of props from the component.
 * @returns
 *   The list of props without the props related to color.
 */
export function excludeColorProps(props) {
  let propsWithoutColorElements = {};
  Object.keys(props).forEach((prop: any) => {
    if (!colorProperties.includes(prop)) {
      propsWithoutColorElements = {
        ...propsWithoutColorElements,
        ...{
          [prop]: props[prop],
        },
      };
    }
  });
  return propsWithoutColorElements;
}
